const url = window.location.href
const { origin } = new URL(url)
let reactAppConfigUrl, reactAppSevenCoreApiUrl

if (origin === process.env.REACT_APP_SSO_REDIRECT_URL_PUB) {
    reactAppConfigUrl = process.env.REACT_APP_CONFIG_URL_PUB
    reactAppSevenCoreApiUrl = process.env.REACT_APP_SEVEN_NOW_CORE_API_URL_PUB
} else {
    reactAppConfigUrl = process.env.REACT_APP_CONFIG_URL
    reactAppSevenCoreApiUrl = process.env.REACT_APP_SEVEN_NOW_CORE_API_URL
}

const appConfig = {
    CONFIG_URL: reactAppConfigUrl,
    SEVEN_NOW_CORE_API_URL: reactAppSevenCoreApiUrl,
}

export default appConfig
